import { render, staticRenderFns } from "./OnboardingForm.vue?vue&type=template&id=3d25c615&scoped=true&"
import script from "./OnboardingForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingForm.vue?vue&type=style&index=0&id=3d25c615&lang=scss&scoped=true&"
import style1 from "./OnboardingForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d25c615",
  null
  
)

export default component.exports